import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import type { AuditAction, AuditLogRow } from '@/lib/database.types';

export interface AuditFilter {
  table?: string | null;
  userId?: string | null;
  action?: AuditAction | null;
  limit?: number;
}

export function useAuditLog(filter: AuditFilter = {}) {
  return useQuery({
    queryKey: ['audit_log', filter],
    queryFn: async (): Promise<AuditLogRow[]> => {
      let q = supabase
        .from('audit_log')
        .select('*')
        .order('ts', { ascending: false })
        .limit(filter.limit ?? 200);
      if (filter.table) q = q.eq('table_name', filter.table);
      if (filter.userId) q = q.eq('user_id', filter.userId);
      if (filter.action) q = q.eq('action', filter.action);
      const { data, error } = await q;
      if (error) throw error;
      return data;
    },
  });
}

// Sprint 9.0 — Liste exhaustive des tables auditées (auto-extraite des migrations
// via grep "attach_audit_log('public.X')"). Mettre à jour quand on ajoute une table.
export const KNOWN_AUDIT_TABLES = [
  // Paramètres
  'entreprises',
  'activites',
  'services',
  'sous_segments',
  'tiers',
  'tiers_contacts',
  'plan_comptable',
  'comptes_bancaires',
  'caisses',
  'banques',
  'workflows_validation',
  'users_metadata',
  'perimetres_utilisateurs',
  'user_entreprises_acces',
  // Finances / Caisse
  'operations',
  'clotures',
  'rapprochements',
  'rapprochement_lignes',
  'justificatifs',
  // Échéances / créances
  'echeances',
  'relances',
  'relance_templates',
  'plans_paiement',
  // CRM
  'opportunites',
  'pipelines',
  'pipeline_etapes',
  'pipeline_champs_custom',
  // Formation
  'formations',
  'formateurs',
  'sessions_formation',
  'inscriptions_formation',
  // Marketing B2C
  'pages_marketing',
  'boosters_marketing',
  'campagnes_boost',
  'leads_marketing',
] as const;
